export default "__VITE_ASSET__CClLU3lH__"